import React from "react";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";

import "./blog.scss";

import Title from "../ui-components/title/title";
import BlogBox from "./blogBox";

class Blog extends React.Component {
  state = {
    stories: [],
    loading: true,
    error: null,
  };

  componentDidMount() {
    fetch("http://localhost:8080/api/blogs")
      .then((res) => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then((data) => {
        const formattedStories = data.map((item) => ({
          id: item.id,
          title: item.title,
          description:
            item.content.length > 100
              ? item.content.substring(0, 100) + "..."
              : item.content,
          date: new Date(item.publishedAt).toLocaleDateString(),
          image: item.imageUrl,
          url: item.link, // ✅ match backend field "link"
        }));
        this.setState({ stories: formattedStories, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  render() {
    const { stories, loading, error } = this.state;

    if (loading) return <div>Loading blog posts...</div>;
    if (error) return <div>Error: {error}</div>;

    const params = {
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      breakpoints: {
        1200: { slidesPerView: 3, spaceBetween: 40 },
        1024: { slidesPerView: 3, spaceBetween: 40 },
        768: { slidesPerView: 2, spaceBetween: 30 },
        640: { slidesPerView: 1, spaceBetween: 20 },
        320: { slidesPerView: 1, spaceBetween: 10 },
      },
    };

    return (
      <div className="blog" id="blog">
        <div className="wrapper">
          <Title title="OUR BLOG" />
          <p className="font12">
            The latest football stories and insights from around the world
          </p>
          <div className="padding30">
            <Swiper {...params}>
              {stories.map((story) => (
                <div key={story.id}>
                  <BlogBox article={story} />
                </div>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    );
  }
}

export default Blog;
